import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { injectIntl, FormattedMessage } from 'react-intl';
import Icon from '../../../components/Icon';
import messages from './messages';
import './styles.css';

class RecommendedCourses extends React.PureComponent {
  static propTypes = {
    admissionsData: PropTypes.object,
    collegeName: PropTypes.string,
  };

  state = {
    sortByName: false,
    sortByRequired: true,
    sortByRecommended: false,
    backwardsSort: true,
  };

  clearSort = () => {
    this.setState({
      sortByName: false,
      sortByRequired: false,
      sortByRecommended: false,
      backwardsSort: false,
    });
  };

  sortByName = () => {
    const backwardsSort = !this.state.backwardsSort && this.state.sortByName;
    this.clearSort();
    this.setState({ sortByName: true, backwardsSort });
  };

  sortByRequired = () => {
    const backwardsSort = !this.state.backwardsSort && this.state.sortByRequired;
    this.clearSort();
    this.setState({ sortByRequired: true, backwardsSort });
  };

  sortByRecommended = () => {
    const backwardsSort = !this.state.backwardsSort && this.state.sortByRecommended;
    this.clearSort();
    this.setState({ sortByRecommended: true, backwardsSort });
  };

  getSortedCourses(recommendedCourses) {
    const { sortByName, sortByRequired, backwardsSort } = this.state;
    const sortedCourses = JSON.parse(JSON.stringify(recommendedCourses)).sort(
      (c1, c2) => {
        if (sortByName) return c1.type.localeCompare(c2.type);
        if (sortByRequired) return c1.requiredYears - c2.requiredYears;
        return c1.recomendationYears - c2.recomendationYears;
      },
    );
    if (backwardsSort) return sortedCourses.reverse();
    return sortedCourses;
  }

  renderRecommendedCourse = (recommendedCourse, index) => {
    const { type, requiredYears, recomendationYears } = recommendedCourse;
    return (
      <div key={index} data-cy="admissions-recommended-courses-list">
        <div className="row-item" data-cy="admissions-recommended-courses-item">
          <div data-cy="admissions-recommended-course-1" className="column-start">
            {type}
          </div>
          <div data-cy="admissions-recommended-course-2" className="column-center">
            {requiredYears || ''}
          </div>
          <div data-cy="admissions-recommended-course-3" className="column-center">
            {recomendationYears || ''}
          </div>
        </div>
        <div className="row-divider" />
      </div>
    );
  };

  renderHeader = () => {
    const { sortByName, sortByRequired, sortByRecommended, backwardsSort } = this.state;
    return (
      <div className="row-header" data-cy="admissions-recommended-courses-header">
        <div
          className="column-header column-start"
          data-cy="admissions-recommended-courses-header-name"
          onClick={this.sortByName}
        >
          <FormattedMessage {...messages.columnName} />
          <div className="sort-icon-container">
            {(!sortByName || !backwardsSort) && (
              <Icon name="caret up" className="sort-icon" />
            )}
            {(!sortByName || backwardsSort) && (
              <Icon name="caret down" className="sort-icon" />
            )}
          </div>
        </div>
        <div
          className="column-header column-center"
          data-cy="admissions-recommended-courses-header-required"
          onClick={this.sortByRequired}
        >
          <FormattedMessage {...messages.columnYearsRequired} />
          <div className="sort-icon-container">
            {(!sortByRequired || !backwardsSort) && (
              <Icon name="caret up" className="sort-icon" />
            )}
            {(!sortByRequired || backwardsSort) && (
              <Icon name="caret down" className="sort-icon" />
            )}
          </div>
        </div>
        <div
          className="column-header column-center"
          data-cy="admissions-recommended-courses-header-recommended"
          onClick={this.sortByRecommended}
        >
          <FormattedMessage {...messages.columnYearsRecommended} />
          <div className="sort-icon-container">
            {(!sortByRecommended || !backwardsSort) && (
              <Icon name="caret up" className="sort-icon" />
            )}
            {(!sortByRecommended || backwardsSort) && (
              <Icon name="caret down" className="sort-icon" />
            )}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { collegeName } = this.props;
    const recommendedCourses = get(this.props.admissionsData, 'recommendedCourses', null);

    if (!recommendedCourses || !recommendedCourses.length) return null;

    return (
      <div id="admissions-recommended-courses" className="common-core-width">
        <h2 data-cy="admissions-recommended-courses-title">
          <FormattedMessage {...messages.title} />
        </h2>
        <div className="subtitle" data-cy="admissions-recommended-courses-subtitle">
          <FormattedMessage {...messages.subtitle} values={{ collegeName }} />
        </div>
        {this.renderHeader()}
        {this.getSortedCourses(recommendedCourses).map(this.renderRecommendedCourse)}
      </div>
    );
  }
}

export default injectIntl(RecommendedCourses);
